/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'phone': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M18.663 16.771s-1.158 1.138-1.442 1.472c-.463.493-1.008.726-1.722.726-.069 0-.142 0-.21-.004-1.361-.087-2.625-.617-3.573-1.07a20.338 20.338 0 01-6.76-5.283C3.395 10.734 2.35 8.997 1.66 7.132c-.426-1.138-.582-2.024-.513-2.86.046-.536.252-.979.632-1.358L3.34 1.355c.224-.21.462-.324.696-.324.288 0 .522.173.668.32l.014.013c.28.26.545.53.824.818.142.147.289.293.436.444l1.25 1.248c.485.484.485.932 0 1.416-.133.133-.261.265-.394.393-.385.393-.083.092-.481.448-.01.01-.018.014-.023.023-.394.393-.32.777-.238 1.038l.014.04c.325.787.783 1.527 1.479 2.41l.005.004c1.264 1.554 2.596 2.765 4.066 3.693.188.119.38.215.564.306.164.082.32.16.453.242.018.01.037.023.055.032a.994.994 0 00.453.114c.38 0 .619-.237.697-.315l.897-.896c.156-.155.403-.342.692-.342.284 0 .517.178.66.333l.008.01 2.524 2.518c.472.466.004 1.43.004 1.43z" _stroke="#5B6881" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/phone.js